// What a blunder or a miss cost, in pawns, counted only inside the zone
// where games are decided. A raw before − after rewards blow-ups in games
// already won (+10 to +4 is six pawns and harmless) and inflates mates; a
// score past ±`DECISIVE_ZONE_PAWNS` is held at the zone's edge, so a move
// costs what it gave up while the game was still to be decided.
//
// A blunder: the score before the move (the best line's) against the score
// after it. A miss: the same two scores, read as the gain the best line
// would have kept against the score the played move left; the fact's
// `before` is the best line's score for both kinds.
import type { MistakeFact } from '@chess/api-model';

/** Scores beyond this many pawns either way are held at it: past it the game is decided. */
export const DECISIVE_ZONE_PAWNS = 3;

const zone = (pawns: number) => Math.max(-DECISIVE_ZONE_PAWNS, Math.min(DECISIVE_ZONE_PAWNS, pawns));

/** Pawns the move gave up (a blunder) or passed over (a miss) inside the decisive zone; never negative. */
export function costOf(m: Pick<MistakeFact, 'before' | 'after'>): number {
  return Math.max(0, zone(m.before) - zone(m.after));
}
